export function createDeadLetterManagementClient(transport) {
    return {
        /**
         * List every tenant's dead letters, as a failure code and a state
         *
         * Requires scope: dead-letter:platform:read
         */
        listPlatformDeadLetters(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/dead-letters",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters
         *
         * Requires scope: dead-letter:receive
         */
        receiveDeadLetter(tenantId, topic, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}
         *
         * Requires scope: dead-letter:read
         */
        getDeadLetter(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}/triage
         *
         * Requires scope: dead-letter:triage
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        triageDeadLetter(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}/triage`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}/quarantine
         *
         * Requires scope: dead-letter:quarantine
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        quarantineDeadLetter(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}/quarantine`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}/retry-request
         *
         * Requires scope: dead-letter:retry-request
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        requestDeadLetterRetry(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}/retry-request`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}/retry-approve
         *
         * Requires scope: dead-letter:retry-approve
         */
        approveDeadLetterRetry(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}/retry-approve`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/topics/{topic}/dead-letters/{deadLetterId}/discard
         *
         * Requires scope: dead-letter:discard
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        discardDeadLetter(tenantId, topic, deadLetterId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/topics/${encodeURIComponent(topic)}/dead-letters/${encodeURIComponent(deadLetterId)}/discard`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=dead-letter-management.js.map